<template>
<div>
    <section id="summary" class="container">
      <div class="segment box">
        <div class="control">
          <label class="label">Penalty Type</label>
          <div class="select">
            <select v-model="PenaltySelected">
            <option v-for="option in PenaltyOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
            </select>
          </div>
        </div>
        <h1 class="title is-uppercase has-text-centered">League Penalty Differentials</h1>
        <h2 class="subtitle has-text-centered">Last Crawler Run - 18-01-2020</h2>
        <sort-table endpoint="https://devilsapi.roblutken.com/api/eihl/penalties/team-diff"
          :postData="[{
          pen_type: PenaltySelected,
          }]"
          :selectedData="[
              {
                title: 'Team',
                prop: 'name'
              }, 
              {
                title: 'Taken',
                prop: 'pims_plus'
              }, 
              {
                title: 'Drawn',
                prop: 'pims_minus'
              }, 
              {
                title: '+/-',
                prop: 'pims_diff'
              }
          ]" @dataLoaded="gameDataLoaded">
        </sort-table>
      </div>
    </section>
</div>
</template>

<script>
import SortTable from '../sort-table'
export default {
  components: {
    SortTable
  },
  data () {
    return {
      PenaltyOptions: [
        {text: 'All', value: 0},
        {text: 'Minor <= 2 mins', value: 1},
        {text: 'Major >= 5 <= 10', value: 2},
        {text: 'Match > 10', value: 3},
        {text: 'Major & Minor', value: 4}
      ],
      PenaltySelected: 0
    }
  },
  methods: {
    gameDataLoaded () {
      console.log('Loaded')
    },
    filterChange () {
      console.log('Filter update: ' + this.PenaltySelected)
    }
  }
}
</script>

<style lang='scss' scoped>

.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// eihl_penalties.vue?4398e84a